import { useStoredData } from "@/store";

export function useViewMode() {
  const storedData = useStoredData();
  return storedData.viewMode;
}
